/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { CmLinkableAsTeaserTarget_CmArticleImpl_Fragment, CmLinkableAsTeaserTarget_CmAudioImpl_Fragment, CmLinkableAsTeaserTarget_CmChannelImpl_Fragment, CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment, CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment, CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment, CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment, CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment, CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment, CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment, CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment, CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment, CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment, CmLinkableAsTeaserTarget_CmMediaImpl_Fragment, CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment, CmLinkableAsTeaserTarget_CmPersonImpl_Fragment, CmLinkableAsTeaserTarget_CmPictureImpl_Fragment, CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment, CmLinkableAsTeaserTarget_CmProductImpl_Fragment, CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment, CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment, CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment, CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment, CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment, CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment, CmLinkableAsTeaserTarget_CmVideoImpl_Fragment, CmLinkableAsTeaserTarget_CmVisualImpl_Fragment, CmLinkableAsTeaserTarget_FormEditorImpl_Fragment, CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment, CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment, CmLinkableAsTeaserTarget_SosChartImpl_Fragment, CmLinkableAsTeaserTarget_SosContactImpl_Fragment, CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment, CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment, CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment, CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment, CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment, CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment, CmLinkableAsTeaserTarget_SosEventImpl_Fragment, CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment, CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment, CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment, CmLinkableAsTeaserTarget_SosLocationImpl_Fragment, CmLinkableAsTeaserTarget_SosNewsImpl_Fragment, CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment, CmLinkableAsTeaserTarget_SosOfferImpl_Fragment, CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment, CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment, CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment, CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment, CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment, CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment, CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment, CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment, CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment, CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment, CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment, CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment, CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment } from './CMLinkableAsTeaserTarget.fragment';
import { CmDownloadFragment } from './CMDownload.fragment';
import { CmExternalLinkFragment } from './CMExternalLink.fragment';
import { gql } from '@apollo/client';
import { CmLinkableAsTeaserTargetFragmentDoc } from './CMLinkableAsTeaserTarget.fragment';
import { CmDownloadFragmentDoc } from './CMDownload.fragment';
import { CmExternalLinkFragmentDoc } from './CMExternalLink.fragment';
export type CmTeasableTeaserTarget_CmArticleImpl_Fragment = { __typename?: 'CMArticleImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmAudioImpl_Fragment = { __typename?: 'CMAudioImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmChannelImpl_Fragment = { __typename?: 'CMChannelImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmCollectionImpl_Fragment = { __typename?: 'CMCollectionImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmDownloadImpl_Fragment = { __typename?: 'CMDownloadImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmDynamicListImpl_Fragment = { __typename?: 'CMDynamicListImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment = { __typename?: 'CMExternalLinkImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmGalleryImpl_Fragment = { __typename?: 'CMGalleryImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmhtmlImpl_Fragment = { __typename?: 'CMHTMLImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmImageMapImpl_Fragment = { __typename?: 'CMImageMapImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmInteractiveImpl_Fragment = { __typename?: 'CMInteractiveImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment = { __typename?: 'CMLocTaxonomyImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmMediaImpl_Fragment = { __typename?: 'CMMediaImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmNavigationImpl_Fragment = { __typename?: 'CMNavigationImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmPersonImpl_Fragment = { __typename?: 'CMPersonImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmPictureImpl_Fragment = { __typename?: 'CMPictureImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment = { __typename?: 'CMPlaceholderImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmProductImpl_Fragment = { __typename?: 'CMProductImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmQueryListImpl_Fragment = { __typename?: 'CMQueryListImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment = { __typename?: 'CMSelectionRulesImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmSpinnerImpl_Fragment = { __typename?: 'CMSpinnerImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment = { __typename?: 'CMTaxonomyImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmTeasableImpl_Fragment = { __typename?: 'CMTeasableImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmTeaserImpl_Fragment = { __typename?: 'CMTeaserImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmVideoImpl_Fragment = { __typename?: 'CMVideoImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_CmVisualImpl_Fragment = { __typename?: 'CMVisualImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_FormEditorImpl_Fragment = { __typename?: 'FormEditorImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment = { __typename?: 'SOSAmountIncreaseFormImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosAuthorImpl_Fragment = { __typename?: 'SOSAuthorImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosChartImpl_Fragment = { __typename?: 'SOSChartImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosContactImpl_Fragment = { __typename?: 'SOSContactImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosDonationCardImpl_Fragment = { __typename?: 'SOSDonationCardImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment = { __typename?: 'SOSDonationCertificateImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosDonationFormImpl_Fragment = { __typename?: 'SOSDonationFormImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosDonationProductImpl_Fragment = { __typename?: 'SOSDonationProductImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment = { __typename?: 'SOSDonationProgressImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosDonationToolImpl_Fragment = { __typename?: 'SOSDonationToolImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosEventImpl_Fragment = { __typename?: 'SOSEventImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment = { __typename?: 'SOSFilterTeaserImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment = { __typename?: 'SOSInternalLinkImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment = { __typename?: 'SOSJobTeaserImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosLocationImpl_Fragment = { __typename?: 'SOSLocationImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosNewsImpl_Fragment = { __typename?: 'SOSNewsImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosNotificationImpl_Fragment = { __typename?: 'SOSNotificationImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosOfferImpl_Fragment = { __typename?: 'SOSOfferImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosOrderFormImpl_Fragment = { __typename?: 'SOSOrderFormImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosOrganisationImpl_Fragment = { __typename?: 'SOSOrganisationImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosOverlayImpl_Fragment = { __typename?: 'SOSOverlayImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment = { __typename?: 'SOSPressreleaseImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosPublicationImpl_Fragment = { __typename?: 'SOSPublicationImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment = { __typename?: 'SOSRedirectPageImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment = { __typename?: 'SOSSpecialTopicCategoryImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment = { __typename?: 'SOSSpecialTopicImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosTeaserImpl_Fragment = { __typename?: 'SOSTeaserImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment = { __typename?: 'SOSTextfragmentImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosTooltipImpl_Fragment = { __typename?: 'SOSTooltipImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment = { __typename?: 'SOSWimmelbildImpl', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment = { __typename?: 'ViewTypeHeroCollection', teaserTarget?: (
    { __typename?: 'CMArticleImpl' }
    & CmLinkableAsTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkableAsTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkableAsTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkableAsTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkableAsTeaserTarget_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkableAsTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkableAsTeaserTarget_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkableAsTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkableAsTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkableAsTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkableAsTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkableAsTeaserTarget_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkableAsTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkableAsTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkableAsTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkableAsTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkableAsTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkableAsTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkableAsTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkableAsTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkableAsTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkableAsTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkableAsTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkableAsTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkableAsTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkableAsTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkableAsTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkableAsTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkableAsTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkableAsTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkableAsTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkableAsTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkableAsTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkableAsTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkableAsTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkableAsTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkableAsTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkableAsTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkableAsTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkableAsTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkableAsTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkableAsTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkableAsTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkableAsTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkableAsTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkableAsTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkableAsTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkableAsTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkableAsTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkableAsTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkableAsTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkableAsTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkableAsTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null };

export type CmTeasableTeaserTargetFragment = CmTeasableTeaserTarget_CmArticleImpl_Fragment | CmTeasableTeaserTarget_CmAudioImpl_Fragment | CmTeasableTeaserTarget_CmChannelImpl_Fragment | CmTeasableTeaserTarget_CmCollectionImpl_Fragment | CmTeasableTeaserTarget_CmDownloadImpl_Fragment | CmTeasableTeaserTarget_CmDynamicListImpl_Fragment | CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment | CmTeasableTeaserTarget_CmGalleryImpl_Fragment | CmTeasableTeaserTarget_CmhtmlImpl_Fragment | CmTeasableTeaserTarget_CmImageMapImpl_Fragment | CmTeasableTeaserTarget_CmInteractiveImpl_Fragment | CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment | CmTeasableTeaserTarget_CmMediaImpl_Fragment | CmTeasableTeaserTarget_CmNavigationImpl_Fragment | CmTeasableTeaserTarget_CmPersonImpl_Fragment | CmTeasableTeaserTarget_CmPictureImpl_Fragment | CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment | CmTeasableTeaserTarget_CmProductImpl_Fragment | CmTeasableTeaserTarget_CmQueryListImpl_Fragment | CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment | CmTeasableTeaserTarget_CmSpinnerImpl_Fragment | CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment | CmTeasableTeaserTarget_CmTeasableImpl_Fragment | CmTeasableTeaserTarget_CmTeaserImpl_Fragment | CmTeasableTeaserTarget_CmVideoImpl_Fragment | CmTeasableTeaserTarget_CmVisualImpl_Fragment | CmTeasableTeaserTarget_FormEditorImpl_Fragment | CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment | CmTeasableTeaserTarget_SosAuthorImpl_Fragment | CmTeasableTeaserTarget_SosChartImpl_Fragment | CmTeasableTeaserTarget_SosContactImpl_Fragment | CmTeasableTeaserTarget_SosDonationCardImpl_Fragment | CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment | CmTeasableTeaserTarget_SosDonationFormImpl_Fragment | CmTeasableTeaserTarget_SosDonationProductImpl_Fragment | CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment | CmTeasableTeaserTarget_SosDonationToolImpl_Fragment | CmTeasableTeaserTarget_SosEventImpl_Fragment | CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment | CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment | CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment | CmTeasableTeaserTarget_SosLocationImpl_Fragment | CmTeasableTeaserTarget_SosNewsImpl_Fragment | CmTeasableTeaserTarget_SosNotificationImpl_Fragment | CmTeasableTeaserTarget_SosOfferImpl_Fragment | CmTeasableTeaserTarget_SosOrderFormImpl_Fragment | CmTeasableTeaserTarget_SosOrganisationImpl_Fragment | CmTeasableTeaserTarget_SosOverlayImpl_Fragment | CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment | CmTeasableTeaserTarget_SosPublicationImpl_Fragment | CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment | CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment | CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment | CmTeasableTeaserTarget_SosTeaserImpl_Fragment | CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment | CmTeasableTeaserTarget_SosTooltipImpl_Fragment | CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment | CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment;

export const CmTeasableTeaserTargetFragmentDoc = gql`
    fragment CMTeasableTeaserTarget on CMTeasable {
  teaserTarget {
    ...CMLinkableAsTeaserTarget
    ...CMDownload
    ...CMExternalLink
  }
}
    ${CmLinkableAsTeaserTargetFragmentDoc}
${CmDownloadFragmentDoc}
${CmExternalLinkFragmentDoc}`;